import {
  VNCATEGORIES_SET_SELECTED_CATEGORY,
  VNCATEGORIES_SET_CATEGORY_SEARCH,
  VNCATEGORIES_REMOVE_FAVORITE_ITEM,
  VNCATEGORIES_ADD_FAVORITE_ITEM,
} from './ActionTypes'
import { FAVORITES_ID } from './Selectors'

/**
 * Selects Display Category
 *
 * @param {String} category
 * @returns
 */
export const setSelectedCategory = (category) => {
  return (dispatch) => {
    dispatch({
      type: VNCATEGORIES_SET_SELECTED_CATEGORY,
      category,
    })
  }
}

/**
 * Adds or Removes Favorite Item - keyed by item and category
 * The same item can occur in multiple categories
 *
 * @param {String} itemId
 * @param {String} categoryId
 * @returns
 */
export const toggleFavoriteItem = (itemId, categoryId) => {
  return (dispatch, getState) => {
    const state = getState()
    const menuId = state.appState?.currentMenuId

    if (!menuId) return

    const curMenuFavorites = state.VNCategories?.favoritesByMenuId?.[menuId]
    const favoritesSet = new Set(curMenuFavorites?.[itemId] || [])

    // If already a favorite, remove it
    if (favoritesSet.has(categoryId) || categoryId === FAVORITES_ID) {
      return dispatch({
        type: VNCATEGORIES_REMOVE_FAVORITE_ITEM,
        itemId,
        categoryId,
        menuId,
      })
    }

    dispatch({
      type: VNCATEGORIES_ADD_FAVORITE_ITEM,
      itemId,
      categoryId,
      menuId,
    })
  }
}

export const setCategorySearch = (query) => {
  return (dispatch) => {
    dispatch({
      type: VNCATEGORIES_SET_CATEGORY_SEARCH,
      query,
    })
  }
}
